module.exports = __webpack_public_path__ + "img/published-products.01752978.svg";